import { Card } from "@/components/ui/card";
import { LucideIcon } from "lucide-react";
import { motion } from "framer-motion";

interface InsightCardProps {
  icon: LucideIcon;
  iconColor: string;
  title: string;
  value: string | number;
  description: string;
  gradientFrom: string;
  gradientTo: string;
  delay?: number;
}

export const InsightCard = ({
  icon: Icon,
  iconColor,
  title,
  value,
  description,
  gradientFrom,
  gradientTo,
  delay = 0
}: InsightCardProps) => {
  return (
    <motion.div 
      initial={{ opacity: 0, y: 20 }} 
      animate={{ opacity: 1, y: 0 }} 
      transition={{ delay }}
    >
      <Card className={`p-6 bg-gradient-to-br from-${gradientFrom} to-${gradientTo} hover:shadow-lg transition-all`}>
        <div className="flex items-center gap-2 mb-2">
          <Icon className={`h-6 w-6 ${iconColor}`} />
          <h3 className="font-semibold">{title}</h3>
        </div>
        <p className="text-2xl font-bold">{value}</p>
        <p className="text-sm text-muted-foreground mt-1">{description}</p>
      </Card>
    </motion.div>
  );
};